<template>
  <div>
    <div class="p-contentplans-nodata">
      <div class="l-block">
        <div class="l-block__header">
          <TitleSub level="h3">
            検索上位ページの文字量や単語の傾向を基に<br />
            作成すべきコンテンツの概要を把握しよう。
          </TitleSub>
        </div>
        <img
          src="@/assets/img/img-content-none01.png"
          alt=""
          width="530"
          height="161"
        />
      </div>
      <div class="l-block">
        <div class="l-block__header">
          <TitleSub level="h3">
            ユーザーのニーズを満たすコンテンツの構成案を<br />
            チャットAIと一緒に作成しよう。
          </TitleSub>
        </div>
        <img
          src="@/assets/img/img-content-none02.png"
          alt=""
          width="530"
          height="161"
        />
      </div>
    </div>

    <div class="p-contentplans-keywords l-block l-mt-6">
      <div class="l-block__content">
        <div class="p-contentplans-keywords__header l-mb-3">
          <div class="l-block__header">
            <TitleSub level="h3">
              <span class="title">過去に調査したキーワード</span>
            </TitleSub>
          </div>
          <dl v-if="usage.max" class="c-list--usage l-ml-2">
            <dt class="c-list--usage__title">
              {{ usage.label }}
              <Tooltip>
                上限は月単位のもので、毎月1日に登録回数がリセットされます。<br />登録回数はサイト単位でカウントされます。
              </Tooltip>
            </dt>
            <dd class="c-list--usage__content">
              <span
                class="c-list--usage__current"
                :class="{ 'is-over': isOver }"
                >{{ usage.current }}</span
              ><span>/</span
              ><span class="c-list--usage__max">{{ usage.max }}</span>
            </dd>
          </dl>
        </div>
        <table class="c-table c-table--hover">
          <thead>
            <tr>
              <ThSort
                v-model="params.sort"
                name="keyword"
                orderby="asc"
                type="string"
              >
                キーワード
              </ThSort>
              <ThSort
                v-model="params.sort"
                name="createdAt"
                orderby="desc"
                type="date"
                width="120"
              >
                調査日
              </ThSort>
              <th width="200"></th>
              <th width="60">削除</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="keyword.isLoading">
              <td colspan="4">
                <Loading variant="inline" />
              </td>
            </tr>
            <tr v-else-if="!keyword.items.length">
              <td colspan="4" class="c-text--center">
                過去に調査したキーワードはありません。
              </td>
            </tr>
            <template v-else>
              <ListItemKeyword
                v-for="item in sortedItems"
                :key="item.keyword"
                :item="item"
                :project="project"
                @delete="deleteItem"
              />
            </template>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import { USAGE_LABEL_DETAIL } from '@/constants';
import ListItemKeyword from '@/components/contentPlans/ListItemKeyword';
import Loading from '@/components/Loading';
import ThSort from '@/components/ThSort';
import TitleSub from '@/components/TitleSub';
import Tooltip from '@/components/Tooltip';
import apiProjects from '@/api/projects';
import utils from '@/utils';

export default {
  props: {
    project: {
      type: Object,
      required: true
    }
  },
  components: {
    ListItemKeyword,
    Loading,
    ThSort,
    TitleSub,
    Tooltip
  },
  data() {
    return {
      keyword: {
        items: [],
        isLoading: true
      },
      params: {
        sort: {
          name: 'createdAt',
          orderby: 'desc',
          type: 'date'
        }
      },
      usage: {
        current: null,
        label: USAGE_LABEL_DETAIL['content-plan-keywords'],
        max: null
      }
    };
  },
  computed: {
    sortedItems() {
      let items = this.keyword.items.slice();
      return utils.sort(
        items,
        this.params.sort.type,
        this.params.sort.orderby,
        this.params.sort.name
      );
    },
    isOver() {
      return this.usage.current >= this.usage.max;
    }
  },
  created() {
    this.getKeywords();
    this.getUsages();
  },
  methods: {
    getKeywords() {
      apiProjects.contentPlans.keywords
        .get(this.auth.idToken, this.project.id)
        .then(response => {
          this.keyword.items = response.data.items;
        })
        .finally(() => {
          this.keyword.isLoading = false;
        });
    },
    getUsages() {
      const params = {
        items: 'content-plan-keywords'
      };
      return apiProjects.usages
        .get(params, this.auth.idToken, this.project.id)
        .then(response => {
          this.usage.current = response.data.items[0].current;
          this.usage.max = response.data.items[0].max;
        });
    },
    deleteItem(item) {
      for (let i = 0; i < this.keyword.items.length; i++) {
        if (this.keyword.items[i].id === item.id) {
          this.keyword.items.splice(i, 1);
          break;
        }
      }
    }
  }
};
</script>
